import Base from '../Base'
import authUtils from './utils'
import { Message } from 'element-ui'
import store from '@/store'
import Vue from 'vue'
import {validateOnlyContent} from '../../utils/permissions'
import { MAIN_URL, WE_MAIN_URL, DOMAIN, WE_DOMAIN } from '@/config'
import { sensorsRegister } from '@/utils/sensors'
// import Cookies from 'js-cookie'
// import { Raven } from '@ecg/vue-raven'

export const getFormatDate = () => {
  const date = new Date()
  const year = date.getFullYear()
  let month = date.getMonth() + 1
  let strDate = ''
  const seperator1 = '-' // 连接年月日
  const seperator2 = ':' // 连接时分秒
  let currentdate = ''
  strDate = date.getDate()
  if (month >= 1 && month <= 9) {
    month = '0' + month
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = '0' + strDate
  }
  return year + seperator1 + month + seperator1 + strDate
}

class Auth extends Base {
  constructor () {
    super()
    this.authUrl = '/app/oneStudent/auth'
    this.loginUrl = '/auth/login'
    this.logoutUrl = '/auth/logout'
    this.profileUrl = '/auth/current'
    this.schoolUrl = '/auth/users'
    this.smsCodeUrl = '/auth/verify_code'
    this.smsLoginUrl = '/app/oneStudent/registerLogin'
    this.resetPasswordUrl = '/auth/change_password'
    this.permissionUrl = '/users/permissions'
    this.messageArr = []
    this.getSchoolPermissonsUrl = '/schools/all-permissions'
    this.openSchoolTryoutUrl = '/schools/apply-trial'
    this.generateOceanUserUrl = '/v1/ocean/open/user/generateUser'
    this.getOrgListUrl = '/student/programmingLessons'
    this.changeOrgUrl = '/app/oneStudent/updateLastSchoolId'
    this.verificationResetCodeUrl = '/auth/check_code'
  }

  /**
   * 认证接口
   * @param { Object } params {telephone, password, type: 1 教师APP、2教师PC、3家长端、18直播云登陆}
   */
  auth (params) {
    return this.sendPost(this.authUrl, params).then(res => {
      if (res.ok) {
        this.handleError(res, {
          success: '登录成功'
        })
        return res
      }
      this.handleError(res, {
        errorOnly: true
      })
    })
  }

  /**
   * 验证码登录
   * @param { telephone } 手机号
   * @param { code } 验证码
   * @param { type }  1|教师APP 2|教师PC 3|学生APP
   */
  smsAuth (params) {
    return this.sendPost(this.smsLoginUrl, params).then(res => {
      if (res.ok) {
        this.handleError(res, {
          success: '登录成功'
        })
        return res
      }
    })
  }

  /**
   * 登录提示
   * options 弹框配置项
   * isUseHTML 是否支持html
   * duration 出现时间ms
   * message 信息
   */
  openMessage (options = {}) {
    if (document.getElementsByClassName('el-message').length === 0) {
      let messageObj = Message.warning({
        dangerouslyUseHTMLString: options.isUseHTML,
        duration: options.duration,
        center: true,
        showClose: true,
        message: options.message
      })
      return messageObj
    }
  }

  // 关闭弹框
  closeMessage () {
    if (this.messageArr.length > 0) {
      this.messageArr.forEach((item) => {
        item.close()
      })
    }
  }

  /**
   * 登录接口
   * @param { Object } params {id, token, type: 1 教师APP、2教师PC、3家长端}
   */
  login (params) {
    if (window.location.href.indexOf('weclassroom') >= 0 || (window.location.href.indexOf('localhost') >= 0 && window.location.href.indexOf('liveAuth') >= 0)) {
      params.type = 18
      localStorage.setItem('is_zby_login', 1)
    } else {
      params.type = 2
      localStorage.setItem('is_zby_login', 0)
    }
    store.dispatch('setIsLogin')
    return this.sendPost(this.loginUrl, params).then(res => {
      if (res.ok) {
        authUtils.removeFullPath()
        res.ok && this.handleLoginSuccess(res.data.token, res.data.user, true)
        res.data.user.school.permissions = res.data.user.school.permissions ? res.data.user.school.permissions : 'academic_affairs'
        authUtils.setTitle(res.data.user.school.name)
        this.setUser(res.data.user)
        store.dispatch('setOnlyContent', validateOnlyContent())
        this.handleError(res, {
          success: '登录成功'
        })
        return res
      }
      this.handleError(res, {
        errorOnly: true
      })
    })
  }

  setUser (user) {
    authUtils.unifySetUserInfo(user)
  }
  /**
   * 统一处理登录成功
   * @param { String } token
   * @param { Object } user
   * @param { Boolean } setRemember
   */
  handleLoginSuccess (token, user, setRemember) {
    authUtils.setToken(token)
    let { id, name, telephone } = user
    sensorsRegister(user, 'loginorgetuser')
    let contractTypes = (user.school && user.school.contract_coop_type_arr) || {}
    store.dispatch('setLoggedUser', JSON.parse(JSON.stringify(user)))
    store.dispatch('setContractTypes', JSON.parse(JSON.stringify(contractTypes)))
    if (setRemember) {
      authUtils.setLastLoggedUser({
        id,
        name,
        telephone
      })
    }
  }

  /**
   * 退出登录
   */
  logout () {
    let params = {
      type: 2
    }
    if (window.location.href.indexOf('weclassroom') >= 0 || (window.location.href.indexOf('localhost') >= 0 && window.location.href.indexOf('liveAuth') >= 0)) {
      params.type = 18
    } else {
      params.type = 2
    }
    store.dispatch('setIsLogin')
    return this.sendPost(this.logoutUrl, params).then(res => {
      if (res.ok) {
        return new Promise((resolve, reject) => {
          authUtils.removeToken()
          authUtils.removeUser(store.getters.isZbyLogin ? WE_DOMAIN : DOMAIN)
          authUtils.removePermissions()
          authUtils.clearLastLoggedUser()
          authUtils.removeFullPath()
          store.dispatch('removeLoggedUser')
          let res = {
            ok: true
          }
          this.handleError(res, {
            success: '退出成功'
          })
          store.dispatch('clearAuthFromStorage')
          resolve(res)
        })
      }
    })
  }

  /**
   * 验证码重置密码
   * @param { telephone }
   * @param { code }
   * @param { password }
   */
  resetPassword (params) {
    return this.sendPost(this.resetPasswordUrl, params).then(res => {
      this.handleError(res, {
        success: '重设密码成功，请重新登录'
      })
      return res
    })
  }

  /**
   * 获取用户信息
   */
  fetchProfile () {
    let params = {
      type: 2 // for PC
    }
    return this.sendGet(this.profileUrl, params).then(res => {
      res.ok && this.handleLoginSuccess(res.data.api_token, res.data, true)
      return res
    })
  }

  /**
   * 获取当前用户学校
   */
  fetchSchool (params) {
    if (window.location.href.indexOf('weclassroom') >= 0 || localStorage.getItem('is_zby_login') === '1') {
      params.type = 18
    } else {
      params.type = 2
    }
    return this.sendGet(this.schoolUrl, params)
  }

  /**
   * 获取短信验证码
   * @param { telephone } 手机号
   * @param { type } 1|登录 2|更改密码 3|更改手机号
   */
  fetchSMSCode (params) {
    return this.sendPost(this.smsCodeUrl, params).then(res => {
      if (!res) return
      let options = res.data.BizCode ? { errorOnly: true } : { success: '获取验证码成功' }
      this.handleError(res, options)
      return res
    })
  }

  /*
  * 获取登录用户权限
  * */
  getUserPermissions (params) {
    return this.sendGet(this.permissionUrl, params).then(res => {
      authUtils.setPermissions(res.data)
      return res
    })
  }

  // 获取各个服务（模块）的状态
  getSchoolPermissons (params) {
    return this.sendPost(this.getSchoolPermissonsUrl, params)
  }

  // 开通试用
  openSchoolTryout (params) {
    return this.sendPost(this.openSchoolTryoutUrl, params, true).then(res => {
      this.handleError(res, { success: '开通成功' })
      return res
    })
  }

  // 无痕开通试用
  openSchoolTryoutTraceless (params) {
    return this.sendPost(this.openSchoolTryoutUrl, params)
  }

  /**
   * 初始化扬帆用户
   * @param { Number } userType 1 saas 2 美校
   */
  generateOceanUser () {
    const params = {
      userType: 1
    }
    return this.sendPost(this.generateOceanUserUrl, params).then(res => {
      console.log('generateOceanUser-then', res)
      if (res && res.status_code === 400 && res.message === 'can not find the ocean user') {
        Vue.prototype.$message.error('没能找到该用户，请联系客服')
      }
      return res
    }).catch((err) => {
      console.log('generateOceanUser-catch', err)
    })
  }

  /***
   * 获取课程列表
   */
  getOrgLessonList () {
    const time = getFormatDate()
    return this.sendGet(`${this.getOrgListUrl}?time=${time}`).then(res => {
      return res
    }).catch((err) => {
      console.log('获取课表失败')
    })
  }

  /**
   * 切换机构
   */
  changeOrg (item) {
    const params = {
      student_id: item.id
    }
    return this.sendPost(this.changeOrgUrl, params).then(res => {
      return res
    }).catch((err) => {
      console.log('切换机构失败', err)
    })
  }
}

export default new Auth()
